export default "__VITE_ASSET__CXC7aOAI__"